export default function EditDepartmentResourcesDialogController(
  $timeout,
  $rootScope,
  $scope,
  $q,
  alerts,
  ssDialogService,
  loaderService,
  bcpDataService
) {
  const vm = this;

  vm.saveAndClose = false;
  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleSaveDepartmentResource = _handleSaveDepartmentResource;
  vm.handleDepartmentResourceSectionLink = _handleDepartmentResourceSectionLink;

  vm.validateControl = _validateControl;
  vm.validationError = _validationError;

  vm.contentPaneIsFaded = false;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    const dfdActivate = $q.defer();

    if (vm.departmentResources) {
      vm.currentAssessmentDepartmentId = vm.departmentResources[0].assessmentDepartmentId;
    } else {
      vm.currentAssessmentDepartmentId = 0;
    }

    dfdActivate.resolve();

    dfdActivate.promise.then(() => {
      loaderService.showViewLoader = false;
    });
  }

  function _handleDepartmentResourceSectionLink($event, assessmentDepartmentId) {
    if (assessmentDepartmentId !== vm.currentAssessmentDepartmentId) {
      vm.contentPaneIsFaded = true;
      $timeout(
        () => {
          vm.currentAssessmentDepartmentId = assessmentDepartmentId;
          vm.contentPaneIsFaded = false;
        },
        100
      );
    }
  }

  function _handleCloseDialog() {
    ssDialogService.hide(ssDialogService.dialogs.bcp.editDepartmentResourcesDialog);
  }

  function _handleSaveDepartmentResource() {
    const dfdSave = $q.defer();

    if ($scope.bcpEditDepartmentResourceForm.$valid || vm.saveAndClose === false) {
      loaderService.showViewLoader = true;

      bcpDataService.saveDepartments(
        vm.departmentResources
      ).then((response) => {
        if (response.data.result) {
          alerts.error('Error occurred while saving Department Resource.');
        } else {
          alerts.success('The BCP Department Resource has been saved successfully.');
          $rootScope.$broadcast('refreshBCPAssessments');
          if (vm.saveAndClose !== false) {
            ssDialogService.hide(ssDialogService.dialogs.bcp.editDepartmentResourcesDialog);
          }
        }
        dfdSave.resolve();
      }).finally(() => {
        loaderService.showViewLoader = false;
      });
    } else {
      dfdSave.reject();
    }
  }

  // validation
  function _validateControl(control, form, ctrlPrefix) {
    const id = ctrlPrefix + control.dept.departmentId;
    const ctrl = angular.element(form[id]);

    return (
      ctrl.$dirty
      && ctrl.$invalid
    ) || (
      form.$submitted
      && ctrl.$invalid
    );
  }

  function _validationError(control, form, ctrlprefix) {
    const id = ctrlprefix + control.dept.departmentId;
    const ctrl = angular.element(form[id]);
    return ctrl.$error;
  }
}

EditDepartmentResourcesDialogController.$inject = [
  '$timeout',
  '$rootScope',
  '$scope',
  '$q',
  'alerts',
  'ssDialogService',
  'loaderService',
  'bcpDataService'
];
